var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 660 660"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#fff;}.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4{clip-path:url(#clip-path);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#505050;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{clip-path:url(#clip-path-4);}.cls-9{clip-path:url(#clip-path-5);}.cls-10{clip-path:url(#clip-path-6);}.cls-11{clip-path:url(#clip-path-7);}.cls-12{clip-path:url(#clip-path-8);}.cls-13{clip-path:url(#clip-path-9);}.cls-14{clip-path:url(#clip-path-10);}.cls-15{clip-path:url(#clip-path-11);}.cls-16{clip-path:url(#clip-path-12);}.cls-17{clip-path:url(#clip-path-13);}.cls-18{clip-path:url(#clip-path-14);}.cls-19{clip-path:url(#clip-path-15);}.cls-20{clip-path:url(#clip-path-16);}.cls-21{clip-path:url(#clip-path-17);}.cls-22{clip-path:url(#clip-path-18);}.cls-23{clip-path:url(#clip-path-19);}.cls-24{clip-path:url(#clip-path-20);}.cls-25{clip-path:url(#clip-path-21);}.cls-26{clip-path:url(#clip-path-22);}.cls-27{clip-path:url(#clip-path-23);}.cls-28{clip-path:url(#clip-path-24);}.cls-29{clip-path:url(#clip-path-25);}.cls-30{clip-path:url(#clip-path-26);}.cls-31{clip-path:url(#clip-path-27);}.cls-32{clip-path:url(#clip-path-28);}.cls-33{clip-path:url(#clip-path-29);}.cls-34{clip-path:url(#clip-path-30);}.cls-35{clip-path:url(#clip-path-31);}.cls-36{clip-path:url(#clip-path-32);}.cls-37{clip-path:url(#clip-path-33);}.cls-38{clip-path:url(#clip-path-34);}.cls-39{clip-path:url(#clip-path-35);}.cls-40{clip-path:url(#clip-path-36);}.cls-41{clip-path:url(#clip-path-37);}.cls-42{clip-path:url(#clip-path-38);}.cls-43{clip-path:url(#clip-path-39);}.cls-44{clip-path:url(#clip-path-40);}.cls-45{clip-path:url(#clip-path-41);}.cls-46{clip-path:url(#clip-path-42);}.cls-47{clip-path:url(#clip-path-43);}.cls-48{clip-path:url(#clip-path-44);}.cls-49{clip-path:url(#clip-path-45);}.cls-50{clip-path:url(#clip-path-46);}.cls-51{clip-path:url(#clip-path-47);}.cls-52{clip-path:url(#clip-path-48);}.cls-53{clip-path:url(#clip-path-49);}.cls-54{clip-path:url(#clip-path-50);}.cls-55{clip-path:url(#clip-path-51);}.cls-56{clip-path:url(#clip-path-52);}.cls-57{clip-path:url(#clip-path-53);}.cls-58{clip-path:url(#clip-path-54);}.cls-59{clip-path:url(#clip-path-55);}.cls-60{clip-path:url(#clip-path-56);}.cls-61{clip-path:url(#clip-path-57);}.cls-62{clip-path:url(#clip-path-58);}.cls-63{clip-path:url(#clip-path-59);}.cls-64{clip-path:url(#clip-path-60);}.cls-65{clip-path:url(#clip-path-61);}.cls-66{clip-path:url(#clip-path-62);}.cls-67{clip-path:url(#clip-path-63);}.cls-68{clip-path:url(#clip-path-64);}.cls-69{clip-path:url(#clip-path-65);}.cls-70{clip-path:url(#clip-path-66);}.cls-71{clip-path:url(#clip-path-67);}.cls-72{clip-path:url(#clip-path-68);}.cls-73{clip-path:url(#clip-path-69);}.cls-74{clip-path:url(#clip-path-70);}.cls-75{clip-path:url(#clip-path-71);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630,240c-.85.84-1.23.26-2.42.26s-1.2-.17-2.4-.17-1.19,0-2.39,0-1.19-.44-2.39-.44-1.19.27-2.39.27-1.19.05-2.39.05-1.19.3-2.39.3-1.19-.11-2.39-.11-1.19-.49-2.39-.49-1.19.32-2.38.32-1.2-.2-2.4-.2-1.19.25-2.39.25-1.19-.17-2.39-.17-1.2.33-2.39.33-1.2-.56-2.4-.56-1.19,0-2.39,0-1.2.31-2.39.31-1.2,0-2.39,0-1.2.14-2.39.14-1.2-.18-2.39-.18-1.2.31-2.4.31-1.19-.38-2.39-.38-1.19-.13-2.39-.13-1.2.56-2.4.56-1.19-.13-2.39-.13-1.2,0-2.39,0-1.2-.31-2.4-.31-1.19.28-2.39.28-1.19.19-2.39.19-1.2-.4-2.39-.4-1.2.15-2.4.15-1.2-.09-2.39-.09-1.2-.2-2.4-.2-1.2.51-2.39.51-1.2.08-2.4.08-1.19-.6-2.39-.6-1.2.6-2.4.6-1.19-.69-2.39-.69H536.7c-1.2,0-1.2.61-2.4.61s-1.2-.6-2.39-.6-1.2.28-2.4.28-1.2-.24-2.4-.24-1.19.62-2.39.62-1.2-.12-2.4-.12-1.19-.32-2.39-.32-1.2-.16-2.4-.16-1.19.1-2.39.1-1.2-.08-2.4-.08-1.19.27-2.39.27-1.2-.27-2.39-.27-1.2.58-2.39.58-1.2-.18-2.4-.18-1.2-.14-2.4-.14-1.19-.29-2.39-.29-1.2.1-2.39.1-1.2,0-2.4,0-1.2-.17-2.4-.17-1.2.21-2.39.21-1.2-.19-2.4-.19-1.2.21-2.4.21-1.2.33-2.4.33-1.2-.53-2.4-.53-1.2.05-2.4.05-1.19,0-2.39,0-1.2.35-2.4.35-1.2-.07-2.4-.07-1.2.22-2.4.22-1.2-.62-2.4-.62-1.2.66-2.4.66-1.76.74-2.62-.11-.13-1.4-.13-2.59.48-1.19.48-2.38,0-1.19,0-2.38.06-1.19.06-2.38-.09-1.19-.09-2.37-.09-1.19-.09-2.38.21-1.19.21-2.38-.35-1.19-.35-2.38,0-1.19,0-2.38-.18-1.19-.18-2.38.45-1.19.45-2.38,0-1.19,0-2.38-.12-1.19-.12-2.38-.2-1.19-.2-2.38.56-1.19.56-2.38-.58-1.19-.58-2.38.16-1.19.16-2.38.21-1.19.21-2.38.22-1.19.22-2.38-.45-1.19-.45-2.38.1-1.19.1-2.38.1-1.19.1-2.38-.13-1.18-.13-2.37-.25-1.19-.25-2.38.08-1.19.08-2.38-.06-1.19-.06-2.38.34-1.19.34-2.38-.39-1.19-.39-2.38.43-1.19.43-2.38-.25-1.2-.25-2.39.34-1.19.34-2.38-.41-1.19-.41-2.38.14-1.19.14-2.38,0-1.2,0-2.39-.15-1.19-.15-2.38.22-1.19.22-2.38.06-1.19.06-2.38.26-1.2.26-2.39-.46-1.19-.46-2.38-.17-1.2-.17-2.39.26-1.2.26-2.39-.85-1.6,0-2.45,1.26-.18,2.45-.18,1.2.15,2.4.15,1.19.09,2.39.09,1.19.13,2.39.13,1.19-.27,2.39-.27h2.39c1.19,0,1.19.41,2.39.41s1.19-.49,2.39-.49,1.19.31,2.39.31,1.19,0,2.38,0h2.4c1.19,0,1.19-.45,2.39-.45s1.19.54,2.39.54,1.2-.4,2.39-.4,1.2.15,2.4.15,1.19-.06,2.39-.06h2.39c1.2,0,1.2.31,2.39.31s1.2.06,2.39.06h2.39c1.2,0,1.2-.29,2.4-.29s1.19.34,2.39.34,1.19-.17,2.39-.17,1.2-.45,2.4-.45,1.19.23,2.39.23,1.2.32,2.39.32,1.2,0,2.4,0,1.19-.46,2.39-.46,1.19,0,2.39,0,1.2.5,2.39.5,1.2-.65,2.4-.65,1.2.62,2.39.62,1.2-.09,2.4-.09,1.2-.38,2.39-.38,1.2.15,2.4.15,1.19.3,2.39.3,1.2-.6,2.4-.6,1.19,0,2.39,0,1.2.21,2.39.21,1.2-.18,2.4-.18h2.39c1.2,0,1.2-.08,2.4-.08s1.2.49,2.4.49,1.19-.41,2.39-.41,1.2.59,2.4.59,1.19-.26,2.39-.26,1.2-.1,2.4-.1,1.19.3,2.39.3,1.2-.07,2.4-.07,1.19.14,2.39.14,1.2-.13,2.39-.13,1.2,0,2.39,0,1.2-.06,2.4-.06,1.2.13,2.4.13,1.19-.36,2.39-.36,1.2-.16,2.39-.16h2.4c1.2,0,1.2.37,2.4.37s1.2.15,2.39.15,1.2-.63,2.4-.63,1.2.63,2.4.63,1.2-.19,2.4-.19,1.2-.46,2.4-.46,1.2.16,2.4.16,1.19-.12,2.39-.12,1.2.47,2.4.47,1.2-.51,2.4-.51,1.2.67,2.4.67,1.2-.05,2.4-.05,1.2.05,2.4.05,1.41-1,2.26-.18-.1,1-.1,2.23.41,1.19.41,2.38.13,1.19.13,2.38-.16,1.19-.16,2.38.09,1.19.09,2.37-.44,1.19-.44,2.38.37,1.19.37,2.38.13,1.19.13,2.38-.34,1.19-.34,2.38-.12,1.19-.12,2.38.36,1.19.36,2.38-.4,1.19-.4,2.38.33,1.19.33,2.38-.06,1.19-.06,2.38-.08,1.19-.08,2.38.37,1.19.37,2.38,0,1.19,0,2.38-.23,1.19-.23,2.38S630,184,630,185.21s-.1,1.19-.1,2.38.31,1.19.31,2.38-.41,1.19-.41,2.38.13,1.18.13,2.37.37,1.19.37,2.38-.29,1.19-.29,2.38.21,1.19.21,2.38-.28,1.19-.28,2.38.22,1.19.22,2.38.15,1.19.15,2.38-.48,1.2-.48,2.39.39,1.19.39,2.38-.57,1.19-.57,2.38.53,1.19.53,2.38-.21,1.2-.21,2.39-.2,1.19-.2,2.38.19,1.19.19,2.38,0,1.19,0,2.38.07,1.2.07,2.39.21,1.19.21,2.38,0,1.2,0,2.39-.8,1.28-.54,2.45S630.87,239.18,630,240Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 580,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 480,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 240,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 120,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 140,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 160,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 180,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 200,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 220,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440,
    y: 240,
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2",
    "data-name": "Vrstva 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 660,
    height: 660
  }), /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630,240c-.85.84-1.23.26-2.42.26s-1.2-.17-2.4-.17-1.19,0-2.39,0-1.19-.44-2.39-.44-1.19.27-2.39.27-1.19.05-2.39.05-1.19.3-2.39.3-1.19-.11-2.39-.11-1.19-.49-2.39-.49-1.19.32-2.38.32-1.2-.2-2.4-.2-1.19.25-2.39.25-1.19-.17-2.39-.17-1.2.33-2.39.33-1.2-.56-2.4-.56-1.19,0-2.39,0-1.2.31-2.39.31-1.2,0-2.39,0-1.2.14-2.39.14-1.2-.18-2.39-.18-1.2.31-2.4.31-1.19-.38-2.39-.38-1.19-.13-2.39-.13-1.2.56-2.4.56-1.19-.13-2.39-.13-1.2,0-2.39,0-1.2-.31-2.4-.31-1.19.28-2.39.28-1.19.19-2.39.19-1.2-.4-2.39-.4-1.2.15-2.4.15-1.2-.09-2.39-.09-1.2-.2-2.4-.2-1.2.51-2.39.51-1.2.08-2.4.08-1.19-.6-2.39-.6-1.2.6-2.4.6-1.19-.69-2.39-.69H536.7c-1.2,0-1.2.61-2.4.61s-1.2-.6-2.39-.6-1.2.28-2.4.28-1.2-.24-2.4-.24-1.19.62-2.39.62-1.2-.12-2.4-.12-1.19-.32-2.39-.32-1.2-.16-2.4-.16-1.19.1-2.39.1-1.2-.08-2.4-.08-1.19.27-2.39.27-1.2-.27-2.39-.27-1.2.58-2.39.58-1.2-.18-2.4-.18-1.2-.14-2.4-.14-1.19-.29-2.39-.29-1.2.1-2.39.1-1.2,0-2.4,0-1.2-.17-2.4-.17-1.2.21-2.39.21-1.2-.19-2.4-.19-1.2.21-2.4.21-1.2.33-2.4.33-1.2-.53-2.4-.53-1.2.05-2.4.05-1.19,0-2.39,0-1.2.35-2.4.35-1.2-.07-2.4-.07-1.2.22-2.4.22-1.2-.62-2.4-.62-1.2.66-2.4.66-1.76.74-2.62-.11-.13-1.4-.13-2.59.48-1.19.48-2.38,0-1.19,0-2.38.06-1.19.06-2.38-.09-1.19-.09-2.37-.09-1.19-.09-2.38.21-1.19.21-2.38-.35-1.19-.35-2.38,0-1.19,0-2.38-.18-1.19-.18-2.38.45-1.19.45-2.38,0-1.19,0-2.38-.12-1.19-.12-2.38-.2-1.19-.2-2.38.56-1.19.56-2.38-.58-1.19-.58-2.38.16-1.19.16-2.38.21-1.19.21-2.38.22-1.19.22-2.38-.45-1.19-.45-2.38.1-1.19.1-2.38.1-1.19.1-2.38-.13-1.18-.13-2.37-.25-1.19-.25-2.38.08-1.19.08-2.38-.06-1.19-.06-2.38.34-1.19.34-2.38-.39-1.19-.39-2.38.43-1.19.43-2.38-.25-1.2-.25-2.39.34-1.19.34-2.38-.41-1.19-.41-2.38.14-1.19.14-2.38,0-1.2,0-2.39-.15-1.19-.15-2.38.22-1.19.22-2.38.06-1.19.06-2.38.26-1.2.26-2.39-.46-1.19-.46-2.38-.17-1.2-.17-2.39.26-1.2.26-2.39-.85-1.6,0-2.45,1.26-.18,2.45-.18,1.2.15,2.4.15,1.19.09,2.39.09,1.19.13,2.39.13,1.19-.27,2.39-.27h2.39c1.19,0,1.19.41,2.39.41s1.19-.49,2.39-.49,1.19.31,2.39.31,1.19,0,2.38,0h2.4c1.19,0,1.19-.45,2.39-.45s1.19.54,2.39.54,1.2-.4,2.39-.4,1.2.15,2.4.15,1.19-.06,2.39-.06h2.39c1.2,0,1.2.31,2.39.31s1.2.06,2.39.06h2.39c1.2,0,1.2-.29,2.4-.29s1.19.34,2.39.34,1.19-.17,2.39-.17,1.2-.45,2.4-.45,1.19.23,2.39.23,1.2.32,2.39.32,1.2,0,2.4,0,1.19-.46,2.39-.46,1.19,0,2.39,0,1.2.5,2.39.5,1.2-.65,2.4-.65,1.2.62,2.39.62,1.2-.09,2.4-.09,1.2-.38,2.39-.38,1.2.15,2.4.15,1.19.3,2.39.3,1.2-.6,2.4-.6,1.19,0,2.39,0,1.2.21,2.39.21,1.2-.18,2.4-.18h2.39c1.2,0,1.2-.08,2.4-.08s1.2.49,2.4.49,1.19-.41,2.39-.41,1.2.59,2.4.59,1.19-.26,2.39-.26,1.2-.1,2.4-.1,1.19.3,2.39.3,1.2-.07,2.4-.07,1.19.14,2.39.14,1.2-.13,2.39-.13,1.2,0,2.39,0,1.2-.06,2.4-.06,1.2.13,2.4.13,1.19-.36,2.39-.36,1.2-.16,2.39-.16h2.4c1.2,0,1.2.37,2.4.37s1.2.15,2.39.15,1.2-.63,2.4-.63,1.2.63,2.4.63,1.2-.19,2.4-.19,1.2-.46,2.4-.46,1.2.16,2.4.16,1.19-.12,2.39-.12,1.2.47,2.4.47,1.2-.51,2.4-.51,1.2.67,2.4.67,1.2-.05,2.4-.05,1.2.05,2.4.05,1.41-1,2.26-.18-.1,1-.1,2.23.41,1.19.41,2.38.13,1.19.13,2.38-.16,1.19-.16,2.38.09,1.19.09,2.37-.44,1.19-.44,2.38.37,1.19.37,2.38.13,1.19.13,2.38-.34,1.19-.34,2.38-.12,1.19-.12,2.38.36,1.19.36,2.38-.4,1.19-.4,2.38.33,1.19.33,2.38-.06,1.19-.06,2.38-.08,1.19-.08,2.38.37,1.19.37,2.38,0,1.19,0,2.38-.23,1.19-.23,2.38S630,184,630,185.21s-.1,1.19-.1,2.38.31,1.19.31,2.38-.41,1.19-.41,2.38.13,1.18.13,2.37.37,1.19.37,2.38-.29,1.19-.29,2.38.21,1.19.21,2.38-.28,1.19-.28,2.38.22,1.19.22,2.38.15,1.19.15,2.38-.48,1.2-.48,2.39.39,1.19.39,2.38-.57,1.19-.57,2.38.53,1.19.53,2.38-.21,1.2-.21,2.39-.2,1.19-.2,2.38.19,1.19.19,2.38,0,1.19,0,2.38.07,1.2.07,2.39.21,1.19.21,2.38,0,1.2,0,2.39-.8,1.28-.54,2.45S630.87,239.18,630,240Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M630,240c-.85.84-1.23.26-2.42.26s-1.2-.17-2.4-.17-1.19,0-2.39,0-1.19-.44-2.39-.44-1.19.27-2.39.27-1.19.05-2.39.05-1.19.3-2.39.3-1.19-.11-2.39-.11-1.19-.49-2.39-.49-1.19.32-2.38.32-1.2-.2-2.4-.2-1.19.25-2.39.25-1.19-.17-2.39-.17-1.2.33-2.39.33-1.2-.56-2.4-.56-1.19,0-2.39,0-1.2.31-2.39.31-1.2,0-2.39,0-1.2.14-2.39.14-1.2-.18-2.39-.18-1.2.31-2.4.31-1.19-.38-2.39-.38-1.19-.13-2.39-.13-1.2.56-2.4.56-1.19-.13-2.39-.13-1.2,0-2.39,0-1.2-.31-2.4-.31-1.19.28-2.39.28-1.19.19-2.39.19-1.2-.4-2.39-.4-1.2.15-2.4.15-1.2-.09-2.39-.09-1.2-.2-2.4-.2-1.2.51-2.39.51-1.2.08-2.4.08-1.19-.6-2.39-.6-1.2.6-2.4.6-1.19-.69-2.39-.69H536.7c-1.2,0-1.2.61-2.4.61s-1.2-.6-2.39-.6-1.2.28-2.4.28-1.2-.24-2.4-.24-1.19.62-2.39.62-1.2-.12-2.4-.12-1.19-.32-2.39-.32-1.2-.16-2.4-.16-1.19.1-2.39.1-1.2-.08-2.4-.08-1.19.27-2.39.27-1.2-.27-2.39-.27-1.2.58-2.39.58-1.2-.18-2.4-.18-1.2-.14-2.4-.14-1.19-.29-2.39-.29-1.2.1-2.39.1-1.2,0-2.4,0-1.2-.17-2.4-.17-1.2.21-2.39.21-1.2-.19-2.4-.19-1.2.21-2.4.21-1.2.33-2.4.33-1.2-.53-2.4-.53-1.2.05-2.4.05-1.19,0-2.39,0-1.2.35-2.4.35-1.2-.07-2.4-.07-1.2.22-2.4.22-1.2-.62-2.4-.62-1.2.66-2.4.66-1.76.74-2.62-.11-.13-1.4-.13-2.59.48-1.19.48-2.38,0-1.19,0-2.38.06-1.19.06-2.38-.09-1.19-.09-2.37-.09-1.19-.09-2.38.21-1.19.21-2.38-.35-1.19-.35-2.38,0-1.19,0-2.38-.18-1.19-.18-2.38.45-1.19.45-2.38,0-1.19,0-2.38-.12-1.19-.12-2.38-.2-1.19-.2-2.38.56-1.19.56-2.38-.58-1.19-.58-2.38.16-1.19.16-2.38.21-1.19.21-2.38.22-1.19.22-2.38-.45-1.19-.45-2.38.1-1.19.1-2.38.1-1.19.1-2.38-.13-1.18-.13-2.37-.25-1.19-.25-2.38.08-1.19.08-2.38-.06-1.19-.06-2.38.34-1.19.34-2.38-.39-1.19-.39-2.38.43-1.19.43-2.38-.25-1.2-.25-2.39.34-1.19.34-2.38-.41-1.19-.41-2.38.14-1.19.14-2.38,0-1.2,0-2.39-.15-1.19-.15-2.38.22-1.19.22-2.38.06-1.19.06-2.38.26-1.2.26-2.39-.46-1.19-.46-2.38-.17-1.2-.17-2.39.26-1.2.26-2.39-.85-1.6,0-2.45,1.26-.18,2.45-.18,1.2.15,2.4.15,1.19.09,2.39.09,1.19.13,2.39.13,1.19-.27,2.39-.27h2.39c1.19,0,1.19.41,2.39.41s1.19-.49,2.39-.49,1.19.31,2.39.31,1.19,0,2.38,0h2.4c1.19,0,1.19-.45,2.39-.45s1.19.54,2.39.54,1.2-.4,2.39-.4,1.2.15,2.4.15,1.19-.06,2.39-.06h2.39c1.2,0,1.2.31,2.39.31s1.2.06,2.39.06h2.39c1.2,0,1.2-.29,2.4-.29s1.19.34,2.39.34,1.19-.17,2.39-.17,1.2-.45,2.4-.45,1.19.23,2.39.23,1.2.32,2.39.32,1.2,0,2.4,0,1.19-.46,2.39-.46,1.19,0,2.39,0,1.2.5,2.39.5,1.2-.65,2.4-.65,1.2.62,2.39.62,1.2-.09,2.4-.09,1.2-.38,2.39-.38,1.2.15,2.4.15,1.19.3,2.39.3,1.2-.6,2.4-.6,1.19,0,2.39,0,1.2.21,2.39.21,1.2-.18,2.4-.18h2.39c1.2,0,1.2-.08,2.4-.08s1.2.49,2.4.49,1.19-.41,2.39-.41,1.2.59,2.4.59,1.19-.26,2.39-.26,1.2-.1,2.4-.1,1.19.3,2.39.3,1.2-.07,2.4-.07,1.19.14,2.39.14,1.2-.13,2.39-.13,1.2,0,2.39,0,1.2-.06,2.4-.06,1.2.13,2.4.13,1.19-.36,2.39-.36,1.2-.16,2.39-.16h2.4c1.2,0,1.2.37,2.4.37s1.2.15,2.39.15,1.2-.63,2.4-.63,1.2.63,2.4.63,1.2-.19,2.4-.19,1.2-.46,2.4-.46,1.2.16,2.4.16,1.19-.12,2.39-.12,1.2.47,2.4.47,1.2-.51,2.4-.51,1.2.67,2.4.67,1.2-.05,2.4-.05,1.2.05,2.4.05,1.41-1,2.26-.18-.1,1-.1,2.23.41,1.19.41,2.38.13,1.19.13,2.38-.16,1.19-.16,2.38.09,1.19.09,2.37-.44,1.19-.44,2.38.37,1.19.37,2.38.13,1.19.13,2.38-.34,1.19-.34,2.38-.12,1.19-.12,2.38.36,1.19.36,2.38-.4,1.19-.4,2.38.33,1.19.33,2.38-.06,1.19-.06,2.38-.08,1.19-.08,2.38.37,1.19.37,2.38,0,1.19,0,2.38-.23,1.19-.23,2.38S630,184,630,185.21s-.1,1.19-.1,2.38.31,1.19.31,2.38-.41,1.19-.41,2.38.13,1.18.13,2.37.37,1.19.37,2.38-.29,1.19-.29,2.38.21,1.19.21,2.38-.28,1.19-.28,2.38.22,1.19.22,2.38.15,1.19.15,2.38-.48,1.2-.48,2.39.39,1.19.39,2.38-.57,1.19-.57,2.38.53,1.19.53,2.38-.21,1.2-.21,2.39-.2,1.19-.2,2.38.19,1.19.19,2.38,0,1.19,0,2.38.07,1.2.07,2.39.21,1.19.21,2.38,0,1.2,0,2.39-.8,1.28-.54,2.45S630.87,239.18,630,240Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "box-2",
    "data-name": "box"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M640,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M590,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M570,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M560,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M545,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M540,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M520,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M510,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M515,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M505,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M500,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M490,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M495,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M485,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M475,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,129a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,119a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,149a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,139a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,169a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,159a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,189a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,179a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,209a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,199a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,229a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,219a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,259a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440,249a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M445,239a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M460.65,241.62a2.14,2.14,0,0,1-1.56-.7,2.27,2.27,0,0,1-.56-2.49,3.61,3.61,0,0,0,.13-.81,3.65,3.65,0,0,1,.31-1.56,1.85,1.85,0,0,0,.17-.82c0-.58,0-.88,0-1.17s0-.6,0-1.21,0-.93,0-1.24,0-.57,0-1.14,0-.83,0-1.11-.05-.63-.05-1.26,0-.84,0-1.12a12,12,0,0,1-.05-1.26,6.48,6.48,0,0,1,.12-1.36,4.87,4.87,0,0,0,.09-1,2.63,2.63,0,0,0-.14-.91,4.83,4.83,0,0,1-.21-1.47v-2.38a6.05,6.05,0,0,0-.08-1,7.56,7.56,0,0,1-.1-1.34,3.81,3.81,0,0,1,.29-1.54,2.09,2.09,0,0,0,.16-.84c0-.58,0-.87,0-1.16s0-.61,0-1.22a8.39,8.39,0,0,0-.06-1.08,11.91,11.91,0,0,1-.06-1.3,5,5,0,0,0-.09-1,7.45,7.45,0,0,1-.11-1.35,3.4,3.4,0,0,1,.38-1.62,1.63,1.63,0,0,0,0-1.51,3.43,3.43,0,0,1-.39-1.63,9.1,9.1,0,0,1,.09-1.33,6.34,6.34,0,0,0,.07-1,6.6,6.6,0,0,1,.12-1.37,4.76,4.76,0,0,0,.09-1,6.43,6.43,0,0,1,.13-1.37,4.76,4.76,0,0,0,.09-1,2,2,0,0,0-.16-.84,3.85,3.85,0,0,1-.29-1.54,11.76,11.76,0,0,1,.06-1.28c0-.27,0-.55,0-1.1s0-.95,0-1.27a9.21,9.21,0,0,0,.05-1.11,8.39,8.39,0,0,0-.06-1.08,11.07,11.07,0,0,1-.07-1.29,4.56,4.56,0,0,0-.1-1,5.69,5.69,0,0,1-.15-1.39c0-.63,0-1,0-1.27s0-.55,0-1.11,0-.85,0-1.14,0-.62,0-1.24a4.83,4.83,0,0,1,.21-1.47,2.66,2.66,0,0,0,.13-.91,2.44,2.44,0,0,0-.14-.88,4.21,4.21,0,0,1-.25-1.5,4.05,4.05,0,0,1,.27-1.53,2,2,0,0,0,.16-.85,4.49,4.49,0,0,0-.1-1,5.86,5.86,0,0,1-.15-1.4,4.75,4.75,0,0,1,.21-1.46,3,3,0,0,0,.13-.92,2.14,2.14,0,0,0-.15-.86,4,4,0,0,1-.27-1.52,8.82,8.82,0,0,1,.09-1.32,8.27,8.27,0,0,0,.06-1.06c0-.61,0-.91,0-1.21s0-.59,0-1.18a6.48,6.48,0,0,0-.07-1.06,9.18,9.18,0,0,1-.08-1.32,6.54,6.54,0,0,1,.13-1.38,4.65,4.65,0,0,0,.09-1c0-.62,0-.93,0-1.24s0-.57,0-1.14a5.89,5.89,0,0,1,.15-1.41,3.83,3.83,0,0,0,.11-1,1.85,1.85,0,0,0-.16-.83,3.83,3.83,0,0,1-.3-1.55,5.22,5.22,0,0,0-.08-1,9.15,9.15,0,0,1-.09-1.34,5.89,5.89,0,0,1,.15-1.41,3.77,3.77,0,0,0,.11-1,2.11,2.11,0,0,0-.17-.75,2,2,0,0,1,.46-2.41,2.19,2.19,0,0,1,2.38-.59,3.1,3.1,0,0,0,.77.12,11,11,0,0,1,1.32.08,6.77,6.77,0,0,0,1.08.07,12.35,12.35,0,0,1,1.27.05c.28,0,.56,0,1.12,0a11.59,11.59,0,0,1,1.3.07,8.45,8.45,0,0,0,1.09.06,3.83,3.83,0,0,0,1-.11,5.3,5.3,0,0,1,1.41-.16h2.39a4.08,4.08,0,0,1,1.52.26,2.2,2.2,0,0,0,.87.15,1.71,1.71,0,0,0,.81-.17,3.81,3.81,0,0,1,1.58-.32,4.94,4.94,0,0,1,1.45.19,3.06,3.06,0,0,0,.94.12h4.77a2.16,2.16,0,0,0,.86-.16,3.81,3.81,0,0,1,1.54-.29,3.47,3.47,0,0,1,1.6.36,1.52,1.52,0,0,0,.79.18,2.29,2.29,0,0,0,.88-.15,4.23,4.23,0,0,1,1.51-.25,9.24,9.24,0,0,1,1.33.08,6.53,6.53,0,0,0,1.07.07c.57,0,.86,0,1.14,0s.63,0,1.25,0h2.39a5.28,5.28,0,0,1,1.45.18,3.05,3.05,0,0,0,.94.13c.63,0,.94,0,1.25,0s.57,0,1.14,0h2.39a3.28,3.28,0,0,0,1-.12,5.32,5.32,0,0,1,1.43-.17,4.89,4.89,0,0,1,1.47.21,2.69,2.69,0,0,0,.92.13,6.43,6.43,0,0,0,1-.07,7.56,7.56,0,0,1,1.34-.1,2.1,2.1,0,0,0,.85-.16,3.86,3.86,0,0,1,1.55-.29,6.73,6.73,0,0,1,1.39.13,4,4,0,0,0,1,.1,5.33,5.33,0,0,1,1.46.19,3,3,0,0,0,.93.13h1.23c.29,0,.58,0,1.17,0a1.92,1.92,0,0,0,.84-.17,3.86,3.86,0,0,1,1.55-.29h2.39a3.65,3.65,0,0,1,1.59.34,1.64,1.64,0,0,0,.8.17,1.28,1.28,0,0,0,.73-.2,3.1,3.1,0,0,1,1.67-.45,3.28,3.28,0,0,1,1.65.42,1.34,1.34,0,0,0,.74.2c.57,0,.84,0,1.13,0a12.07,12.07,0,0,1,1.27-.05,2.27,2.27,0,0,0,.89-.15,4.62,4.62,0,0,1,1.5-.23,9.18,9.18,0,0,1,1.32.08,6.77,6.77,0,0,0,1.08.07,5.25,5.25,0,0,1,1.44.18,3.18,3.18,0,0,0,1,.12,1.35,1.35,0,0,0,.75-.19,3.19,3.19,0,0,1,1.64-.41c.62,0,.93,0,1.23,0h1.17a7.49,7.49,0,0,1,1.37.12,4.8,4.8,0,0,0,1,.09,6.33,6.33,0,0,0,1.06-.08,8.68,8.68,0,0,1,1.34-.1h2.39c.57,0,.86,0,1.14,0s.63,0,1.26,0a3.67,3.67,0,0,1,1.57.32,1.75,1.75,0,0,0,.82.17,2.25,2.25,0,0,0,.88-.15,4,4,0,0,1,1.52-.26,3.44,3.44,0,0,1,1.64.39,1.34,1.34,0,0,0,.76.2,3.92,3.92,0,0,0,1-.11,5.86,5.86,0,0,1,1.4-.15c.56,0,.84,0,1.12,0a11.76,11.76,0,0,1,1.28-.06,5.25,5.25,0,0,1,1.44.18,3.13,3.13,0,0,0,1,.12c.57,0,.85,0,1.14,0s.63,0,1.26,0a9.18,9.18,0,0,1,1.32.08,8.33,8.33,0,0,0,1.07.06,8.7,8.7,0,0,0,1.09-.06,11.13,11.13,0,0,1,1.3-.07h2.39c.58,0,.87,0,1.15,0s.63,0,1.25,0a11.49,11.49,0,0,1,1.31.07,8.45,8.45,0,0,0,1.09.06,2.52,2.52,0,0,0,.9-.14,4.56,4.56,0,0,1,1.49-.22,6.72,6.72,0,0,0,1.07-.07,8.82,8.82,0,0,1,1.32-.09h2.4a4.5,4.5,0,0,1,1.49.23,2.63,2.63,0,0,0,.91.14,9.18,9.18,0,0,1,1.32.08,6.72,6.72,0,0,0,1.07.07,1.32,1.32,0,0,0,.74-.2,3.18,3.18,0,0,1,1.66-.43,3.25,3.25,0,0,1,1.67.43,1.28,1.28,0,0,0,.73.2,6.05,6.05,0,0,0,1-.08,7.59,7.59,0,0,1,1.36-.11,1.93,1.93,0,0,0,.84-.16,3.68,3.68,0,0,1,1.56-.3,9,9,0,0,1,1.33.09,6.53,6.53,0,0,0,1.07.07,8.58,8.58,0,0,0,1.09-.06,12.21,12.21,0,0,1,1.3-.06,3.94,3.94,0,0,1,1.57.3,1.74,1.74,0,0,0,.83.17,1.64,1.64,0,0,0,.8-.17,3.7,3.7,0,0,1,1.6-.34,3.17,3.17,0,0,1,1.69.46,1.11,1.11,0,0,0,.71.21c.58,0,.87,0,1.16,0s.62,0,1.24,0l1.24,0c.29,0,.58,0,1.16,0a1.23,1.23,0,0,0,.63-.2,1.75,1.75,0,0,1,2.34.31,1.77,1.77,0,0,1,.37,2.31,1.39,1.39,0,0,0-.18.63,2.18,2.18,0,0,0,.15.86,4,4,0,0,1,.26,1.52,8.39,8.39,0,0,0,.06,1.08,11.28,11.28,0,0,1,.07,1.3,8.82,8.82,0,0,1-.09,1.32,7.87,7.87,0,0,0-.07,1.06,9.46,9.46,0,0,0,0,1.11c0,.32,0,.63,0,1.26a4.09,4.09,0,0,1-.28,1.55,1.85,1.85,0,0,0-.16.83,2.5,2.5,0,0,0,.14.89,4.5,4.5,0,0,1,.23,1.49,8.39,8.39,0,0,0,.06,1.08,11.28,11.28,0,0,1,.07,1.3,4.53,4.53,0,0,1-.21,1.47,2.89,2.89,0,0,0-.13.91,9.35,9.35,0,0,1-.07,1.3,8.87,8.87,0,0,0,0,1.08,2.56,2.56,0,0,0,.13.9,4.48,4.48,0,0,1,.23,1.48,4,4,0,0,1-.26,1.51,2.42,2.42,0,0,0-.14.87,2.69,2.69,0,0,0,.13.92,4.88,4.88,0,0,1,.2,1.46c0,.62,0,.93,0,1.24s0,.57,0,1.14,0,.94,0,1.26,0,.56,0,1.12a2.5,2.5,0,0,0,.14.89,4.5,4.5,0,0,1,.23,1.49v2.38a6.54,6.54,0,0,1-.13,1.38,4.52,4.52,0,0,0-.1,1,11.91,11.91,0,0,1-.06,1.3,8.39,8.39,0,0,0-.06,1.08,11.76,11.76,0,0,1-.06,1.28c0,.28,0,.55,0,1.1a3.06,3.06,0,0,0,.12.94,5.16,5.16,0,0,1,.19,1.44,4.18,4.18,0,0,1-.26,1.51,2.23,2.23,0,0,0-.15.87,8.39,8.39,0,0,0,.06,1.08,10.92,10.92,0,0,1,.07,1.29,2.56,2.56,0,0,0,.14.9,4.48,4.48,0,0,1,.23,1.48,5.7,5.7,0,0,1-.17,1.43,3.18,3.18,0,0,0-.12.95,4.8,4.8,0,0,0,.09,1,7.36,7.36,0,0,1,.12,1.36,5.29,5.29,0,0,1-.17,1.42,3.65,3.65,0,0,0-.11,1,4.76,4.76,0,0,0,.09,1,6.5,6.5,0,0,1,.13,1.37,6.62,6.62,0,0,0,.07,1.07,9.13,9.13,0,0,1,.08,1.31,3.74,3.74,0,0,1-.31,1.57,1.73,1.73,0,0,0-.17.82,2.25,2.25,0,0,0,.15.88,4.22,4.22,0,0,1,.24,1.5,3.4,3.4,0,0,1-.38,1.62,1.42,1.42,0,0,0-.19.76,1.62,1.62,0,0,0,.18.79,3.48,3.48,0,0,1,.35,1.59,6.6,6.6,0,0,1-.12,1.37,4.8,4.8,0,0,0-.09,1,7.59,7.59,0,0,1-.11,1.36,4.8,4.8,0,0,0-.09,1,5.83,5.83,0,0,0,.08,1,7.55,7.55,0,0,1,.11,1.35c0,.58,0,.87,0,1.17s0,.61,0,1.21,0,.85,0,1.14,0,.62,0,1.25a4.8,4.8,0,0,0,.09,1,6.56,6.56,0,0,1,.12,1.36V234c0,.3,0,.6,0,1.2a3.15,3.15,0,0,1-.45,1.63c-.15.29-.18.34-.12.6a2.77,2.77,0,0,0,.32.78,1.85,1.85,0,0,1-.3,2.5,2.24,2.24,0,0,1-2.36.66,3.5,3.5,0,0,0-.76-.1,9,9,0,0,1-1.34-.09,6.23,6.23,0,0,0-1.06-.08l-1.16,0c-.3,0-.61,0-1.23,0a3.85,3.85,0,0,1-1.54-.29,2.12,2.12,0,0,0-.85-.15,3.74,3.74,0,0,0-1,.11A5.39,5.39,0,0,1,618,241c-.58,0-.87,0-1.15,0l-1.24,0a3.49,3.49,0,0,0-.95.12,5.25,5.25,0,0,1-1.44.18,12.14,12.14,0,0,1-1.29-.06,9.14,9.14,0,0,0-1.1,0,3.71,3.71,0,0,1-1.57-.32,1.73,1.73,0,0,0-.82-.17,2.69,2.69,0,0,0-.92.13,5.26,5.26,0,0,1-1.47.2,7.36,7.36,0,0,1-1.36-.12,4.8,4.8,0,0,0-1-.09,4.42,4.42,0,0,0-1,.1,5.89,5.89,0,0,1-1.41.15A7.65,7.65,0,0,1,600,241a6.34,6.34,0,0,0-1.05-.07,2.75,2.75,0,0,0-.93.13,4.83,4.83,0,0,1-1.46.2,3.51,3.51,0,0,1-1.62-.37,1.5,1.5,0,0,0-.78-.19h-1.22c-.29,0-.58,0-1.17,0a3,3,0,0,0-.94.13,5.4,5.4,0,0,1-1.45.18c-.62,0-.92,0-1.23,0L587,241a8.84,8.84,0,0,0-1.09.06,9.82,9.82,0,0,1-2.65,0,5.17,5.17,0,0,0-1-.08,3.08,3.08,0,0,0-.95.12,5.28,5.28,0,0,1-1.45.18,4.5,4.5,0,0,1-1.49-.23,2.52,2.52,0,0,0-.9-.14,11.59,11.59,0,0,1-1.3-.07,8.45,8.45,0,0,0-1.09-.06,1.5,1.5,0,0,0-.78.19,3.55,3.55,0,0,1-1.62.37,11.28,11.28,0,0,1-1.3-.07,8.58,8.58,0,0,0-1.09-.06h-2.39a5.18,5.18,0,0,1-1.45-.19,3.43,3.43,0,0,0-1-.12,3.21,3.21,0,0,0-1,.12,6,6,0,0,1-1.43.16,5,5,0,0,0-1,.09,7.79,7.79,0,0,1-1.35.1,4.23,4.23,0,0,1-1.51-.25,2.29,2.29,0,0,0-.88-.15,6.77,6.77,0,0,0-1.08.07,9.18,9.18,0,0,1-1.32.08c-.64,0-1,0-1.27,0s-.57,0-1.12,0a7.59,7.59,0,0,1-1.36-.11,5,5,0,0,0-1-.09,1.7,1.7,0,0,0-.81.18,3.62,3.62,0,0,1-1.58.33c-.57,0-.85,0-1.13,0s-.63,0-1.27,0a3.31,3.31,0,0,1-1.64-.4,1.3,1.3,0,0,0-.75-.2,1.35,1.35,0,0,0-.75.2,3.31,3.31,0,0,1-1.64.4,3,3,0,0,1-1.7-.48,1.16,1.16,0,0,0-.7-.21H536.7a1.33,1.33,0,0,0-.75.2,3.51,3.51,0,0,1-3.29,0,1.35,1.35,0,0,0-.75-.19,3.23,3.23,0,0,0-1,.12,6,6,0,0,1-1.43.16,5.82,5.82,0,0,1-1.39-.14,4.59,4.59,0,0,0-1-.1,1.29,1.29,0,0,0-.74.2,3.26,3.26,0,0,1-1.66.42,11.76,11.76,0,0,1-1.3-.06,8.64,8.64,0,0,0-1.1-.06,4.75,4.75,0,0,1-1.45-.2,3.16,3.16,0,0,0-.94-.12,8.87,8.87,0,0,1-1.33-.09,6.62,6.62,0,0,0-1.07-.07,9.33,9.33,0,0,0-1.11.05c-.32,0-.64.05-1.28.05s-.95,0-1.27,0-.56,0-1.13,0a3.68,3.68,0,0,0-1,.11,5.45,5.45,0,0,1-1.42.16,5.39,5.39,0,0,1-1.42-.16,3.74,3.74,0,0,0-1-.11,1.42,1.42,0,0,0-.76.19,3.43,3.43,0,0,1-1.63.39,8.73,8.73,0,0,1-1.35-.1,5.29,5.29,0,0,0-1.05-.08,9.18,9.18,0,0,1-1.32-.08,8.23,8.23,0,0,0-1.08-.07,5.44,5.44,0,0,1-1.43-.17,3.65,3.65,0,0,0-1-.11,9.46,9.46,0,0,0-1.11.05c-.32,0-.64,0-1.28,0h-2.4a7.56,7.56,0,0,1-1.34-.1,6.48,6.48,0,0,0-1.06-.07,4.8,4.8,0,0,0-1,.09,6.68,6.68,0,0,1-1.37.12,7.59,7.59,0,0,1-1.36-.11,6.05,6.05,0,0,0-1-.08,5,5,0,0,0-1,.09,6.6,6.6,0,0,1-1.37.12,3,3,0,0,0-.93.13,4.91,4.91,0,0,1-1.47.2,3.5,3.5,0,0,1-1.6-.35,1.63,1.63,0,0,0-.8-.18c-.58,0-.87,0-1.15,0s-.63,0-1.25,0h-1.17l-1.22,0a2.62,2.62,0,0,0-.91.13,4.56,4.56,0,0,1-1.49.22c-.63,0-.94,0-1.26,0s-.57,0-1.14,0a4.87,4.87,0,0,0-1,.09,6.54,6.54,0,0,1-1.38.13,3.33,3.33,0,0,1-1.66-.42,1.24,1.24,0,0,0-.74-.2,1.22,1.22,0,0,0-.72.2,3.07,3.07,0,0,1-1.68.46,3.13,3.13,0,0,0-.82.14A3.68,3.68,0,0,1,460.65,241.62Zm-.27-2.26a.5.5,0,0,0,.11.14.56.56,0,0,0,.15.12,3.34,3.34,0,0,0,.43-.09,4.88,4.88,0,0,1,1.34-.21,1.17,1.17,0,0,0,.71-.21,3.18,3.18,0,0,1,1.69-.45,3.23,3.23,0,0,1,1.66.42,1.34,1.34,0,0,0,.74.2,4.8,4.8,0,0,0,1-.09,6.62,6.62,0,0,1,1.38-.13c.63,0,.95,0,1.26,0s.57,0,1.14,0a2.69,2.69,0,0,0,.92-.13,4.54,4.54,0,0,1,1.48-.22c.59,0,.88,0,1.17,0h1.22l1.16,0c.31,0,.62,0,1.24,0a3.58,3.58,0,0,1,1.61.35,1.59,1.59,0,0,0,.79.18,3.05,3.05,0,0,0,.94-.13,4.83,4.83,0,0,1,1.46-.2,5,5,0,0,0,1-.09,6.6,6.6,0,0,1,1.37-.12,7.36,7.36,0,0,1,1.35.11,6.19,6.19,0,0,0,1.05.08,4.8,4.8,0,0,0,1-.09,6.68,6.68,0,0,1,1.37-.12,9,9,0,0,1,1.34.09,6.33,6.33,0,0,0,1.06.08H496a9.14,9.14,0,0,0,1.1,0c.33,0,.65-.05,1.29-.05a5.32,5.32,0,0,1,1.43.17,3.65,3.65,0,0,0,1,.11,11,11,0,0,1,1.32.08,6.77,6.77,0,0,0,1.08.07,7.79,7.79,0,0,1,1.35.1,6.1,6.1,0,0,0,1.05.08,1.45,1.45,0,0,0,.76-.19,3.28,3.28,0,0,1,1.63-.39,5.45,5.45,0,0,1,1.42.16,3.68,3.68,0,0,0,1,.11,3.74,3.74,0,0,0,1-.11,5.94,5.94,0,0,1,1.42-.16c.63,0,1,0,1.26,0s.57,0,1.14,0a9.33,9.33,0,0,0,1.11-.05c.32,0,.64-.05,1.28-.05a8.87,8.87,0,0,1,1.33.09,6.62,6.62,0,0,0,1.07.07,5.18,5.18,0,0,1,1.45.19,2.86,2.86,0,0,0,.94.13,11.34,11.34,0,0,1,1.31.07,8.94,8.94,0,0,0,1.09.05,1.31,1.31,0,0,0,.74-.19,3.18,3.18,0,0,1,1.66-.43,6.57,6.57,0,0,1,1.39.14,4,4,0,0,0,1,.1,3.74,3.74,0,0,0,1-.11,5.32,5.32,0,0,1,1.43-.17,3.31,3.31,0,0,1,1.64.4,1.51,1.51,0,0,0,1.5,0,3.3,3.3,0,0,1,1.65-.41h2.39a3.1,3.1,0,0,1,1.7.48,1.14,1.14,0,0,0,.7.21,1.35,1.35,0,0,0,.75-.19,3.49,3.49,0,0,1,3.28,0,1.44,1.44,0,0,0,.75.19c.57,0,.85,0,1.14,0s.63,0,1.26,0a1.76,1.76,0,0,0,.8-.17,3.69,3.69,0,0,1,1.59-.34,7.59,7.59,0,0,1,1.36.11,5,5,0,0,0,1,.09,12.35,12.35,0,0,1,1.27.05c.28,0,.56,0,1.12,0a6.77,6.77,0,0,0,1.08-.07,11,11,0,0,1,1.32-.08,4.28,4.28,0,0,1,1.51.25,2.25,2.25,0,0,0,.88.15,6.05,6.05,0,0,0,1-.08,7.55,7.55,0,0,1,1.35-.11,3.74,3.74,0,0,0,1-.11,6,6,0,0,1,2.87,0,3,3,0,0,0,1,.13h2.39a11.28,11.28,0,0,1,1.3.07,8.58,8.58,0,0,0,1.09.06,1.5,1.5,0,0,0,.78-.19,3.55,3.55,0,0,1,1.62-.37,11.59,11.59,0,0,1,1.3.07,8.45,8.45,0,0,0,1.09.06,4.57,4.57,0,0,1,1.5.23,2.29,2.29,0,0,0,.89.14,3.18,3.18,0,0,0,1-.12,5.28,5.28,0,0,1,1.45-.18,7.56,7.56,0,0,1,1.34.1,6.1,6.1,0,0,0,1.05.08,8.65,8.65,0,0,0,1.08-.06A9,9,0,0,1,587,239l1.23,0c.29,0,.58,0,1.16,0a3.06,3.06,0,0,0,.94-.12,5.18,5.18,0,0,1,1.45-.19l1.22,0h1.17a3.55,3.55,0,0,1,1.62.37,1.5,1.5,0,0,0,.78.19,3.08,3.08,0,0,0,.93-.13,4.83,4.83,0,0,1,1.46-.2,7.56,7.56,0,0,1,1.34.1,6.43,6.43,0,0,0,1,.07,4,4,0,0,0,1-.1,5.89,5.89,0,0,1,1.41-.15,6.56,6.56,0,0,1,1.36.12,5.67,5.67,0,0,0,1,.09A3,3,0,0,0,607,239a4.88,4.88,0,0,1,1.46-.2,3.58,3.58,0,0,1,1.58.32,1.81,1.81,0,0,0,.81.17,11.83,11.83,0,0,1,1.29.06c.28,0,.55,0,1.1,0a3.21,3.21,0,0,0,1-.12,5.16,5.16,0,0,1,1.43-.18c.58,0,.87,0,1.15,0s.62,0,1.24,0a3.35,3.35,0,0,0,1-.11,5.39,5.39,0,0,1,1.42-.16A3.84,3.84,0,0,1,622,239a2.1,2.1,0,0,0,.85.16c.58,0,.87,0,1.16,0l1.23,0a7.56,7.56,0,0,1,1.34.1,6.48,6.48,0,0,0,1.06.07,5.3,5.3,0,0,1,1.16.14l.35.06a1.93,1.93,0,0,0,.2-.17h0l0,0-.07-.12a4.79,4.79,0,0,1-.51-1.3,2.6,2.6,0,0,1,.31-2,1.14,1.14,0,0,0,.21-.68V234c0-.3,0-.6,0-1.21a4.87,4.87,0,0,0-.09-1,6.56,6.56,0,0,1-.12-1.36c0-.57,0-.85,0-1.13s0-.63,0-1.26,0-.87,0-1.16,0-.61,0-1.22a6,6,0,0,0-.08-1,7.45,7.45,0,0,1-.11-1.35,7.59,7.59,0,0,1,.11-1.36,4.8,4.8,0,0,0,.09-1,6.6,6.6,0,0,1,.12-1.37,4.8,4.8,0,0,0,.09-1,1.5,1.5,0,0,0-.18-.78,3.63,3.63,0,0,1-.35-1.6,3.27,3.27,0,0,1,.39-1.62,1.43,1.43,0,0,0,.18-.76,2.44,2.44,0,0,0-.14-.88,4.21,4.21,0,0,1-.25-1.5,3.74,3.74,0,0,1,.31-1.57,1.7,1.7,0,0,0,.17-.82,8.27,8.27,0,0,0-.06-1.06,8.82,8.82,0,0,1-.09-1.32,4.65,4.65,0,0,0-.09-1,6.54,6.54,0,0,1-.13-1.38,5.94,5.94,0,0,1,.16-1.42,3.21,3.21,0,0,0,.12-1,5.67,5.67,0,0,0-.09-1,6.56,6.56,0,0,1-.12-1.36,5.68,5.68,0,0,1,.17-1.42,3.21,3.21,0,0,0,.12-1,2.5,2.5,0,0,0-.14-.89,4.25,4.25,0,0,1-.23-1.49,8.39,8.39,0,0,0-.06-1.08,9.18,9.18,0,0,1-.07-1.29,4,4,0,0,1,.26-1.52,2.14,2.14,0,0,0,.15-.86,2.93,2.93,0,0,0-.13-.93,5.28,5.28,0,0,1-.18-1.45,12.35,12.35,0,0,1,.05-1.27,9.46,9.46,0,0,0,0-1.11,11.07,11.07,0,0,1,.07-1.29,8.94,8.94,0,0,0,0-1.09,6.43,6.43,0,0,1,.13-1.37,4.07,4.07,0,0,0,.1-1v-2.38a2.5,2.5,0,0,0-.14-.89,4.5,4.5,0,0,1-.23-1.49c0-.63,0-.94,0-1.25s0-.57,0-1.13,0-.93,0-1.24,0-.57,0-1.14A2.69,2.69,0,0,0,629,170a4.83,4.83,0,0,1-.2-1.46A4.28,4.28,0,0,1,629,167a2.2,2.2,0,0,0,.15-.87,2.52,2.52,0,0,0-.14-.9,4.54,4.54,0,0,1-.22-1.48,11.54,11.54,0,0,1,.06-1.29,8.58,8.58,0,0,0,.06-1.09,4.75,4.75,0,0,1,.21-1.46,2.69,2.69,0,0,0,.13-.92,8.39,8.39,0,0,0-.06-1.08,11.13,11.13,0,0,1-.07-1.3,2.5,2.5,0,0,0-.14-.89,4.5,4.5,0,0,1-.23-1.49,4.07,4.07,0,0,1,.28-1.54,1.87,1.87,0,0,0,.16-.84c0-.55,0-.83,0-1.11s0-.63,0-1.26a8.7,8.7,0,0,1,.09-1.32,6.57,6.57,0,0,0,.07-1.06,8.7,8.7,0,0,0-.06-1.09,10.92,10.92,0,0,1-.07-1.29,2.14,2.14,0,0,0-.15-.86,4.08,4.08,0,0,1-.26-1.52,3.18,3.18,0,0,1,.36-1.46,3.16,3.16,0,0,1-1.52.41c-.62,0-.92,0-1.24,0l-1.16,0c-.58,0-.87,0-1.16,0s-.62,0-1.24,0a3.17,3.17,0,0,1-1.69-.46,1.19,1.19,0,0,0-.71-.21,1.68,1.68,0,0,0-.81.18,4.06,4.06,0,0,1-3.16,0,1.88,1.88,0,0,0-.83-.16,9.26,9.26,0,0,0-1.1.05,9.39,9.39,0,0,1-1.29.07,9,9,0,0,1-1.34-.09,6.48,6.48,0,0,0-1.06-.07,1.87,1.87,0,0,0-.84.16,3.76,3.76,0,0,1-1.56.3,6.19,6.19,0,0,0-1,.08,7.36,7.36,0,0,1-1.35.11,3.25,3.25,0,0,1-1.67-.43,1.43,1.43,0,0,0-1.46,0,3.25,3.25,0,0,1-1.67.43,8.82,8.82,0,0,1-1.32-.09,8.59,8.59,0,0,0-1.07-.06,4.5,4.5,0,0,1-1.49-.23,2.63,2.63,0,0,0-.91-.14H594a7.87,7.87,0,0,0-1.06.07,9.1,9.1,0,0,1-1.33.09,2.63,2.63,0,0,0-.91.14,4.54,4.54,0,0,1-1.48.22,11.19,11.19,0,0,1-1.31-.07,8.58,8.58,0,0,0-1.09-.06c-.58,0-.86,0-1.15,0s-.62,0-1.25,0H582a8.39,8.39,0,0,0-1.08.06,11.49,11.49,0,0,1-1.31.07,9.18,9.18,0,0,1-1.32-.08,8.33,8.33,0,0,0-1.07-.06c-.57,0-.85,0-1.14,0s-.63,0-1.26,0a5.25,5.25,0,0,1-1.44-.18,3.49,3.49,0,0,0-.95-.12c-.56,0-.84,0-1.12.05a12.44,12.44,0,0,1-1.28.05,3.92,3.92,0,0,0-1,.11,5.86,5.86,0,0,1-1.4.15,3.28,3.28,0,0,1-1.64-.4,1.42,1.42,0,0,0-.76-.19,2.2,2.2,0,0,0-.87.15,4.1,4.1,0,0,1-1.53.26,3.71,3.71,0,0,1-1.57-.32,1.85,1.85,0,0,0-.82-.17c-.57,0-.85,0-1.13,0s-.64,0-1.27,0H555.7a6.1,6.1,0,0,0-1.05.08,7.7,7.7,0,0,1-1.35.1,6.56,6.56,0,0,1-1.36-.12,5,5,0,0,0-1-.09h-1.23c-.29,0-.58,0-1.17,0a1.31,1.31,0,0,0-.74.19,3.2,3.2,0,0,1-1.65.41,5.34,5.34,0,0,1-1.45-.18,3.06,3.06,0,0,0-.94-.12,8.87,8.87,0,0,1-1.33-.09,8.33,8.33,0,0,0-1.07-.06,2.5,2.5,0,0,0-.89.14,4.51,4.51,0,0,1-1.5.24c-.56,0-.84,0-1.12,0s-.64.05-1.28.05a3.21,3.21,0,0,1-1.65-.42,1.32,1.32,0,0,0-.74-.2,1.18,1.18,0,0,0-.72.21,3.25,3.25,0,0,1-1.68.44,3.62,3.62,0,0,1-1.58-.33,1.68,1.68,0,0,0-.81-.18H527a1.9,1.9,0,0,0-.84.16,3.83,3.83,0,0,1-1.55.3c-.61,0-.92,0-1.22,0h-1.18a4.8,4.8,0,0,1-1.45-.2,3.06,3.06,0,0,0-.94-.12,6,6,0,0,1-1.39-.14,4.72,4.72,0,0,0-1-.09,2,2,0,0,0-.85.16,3.86,3.86,0,0,1-1.55.29,6.43,6.43,0,0,0-1,.07,7.56,7.56,0,0,1-1.34.1,4.48,4.48,0,0,1-1.47-.21,3,3,0,0,0-.92-.13,3.28,3.28,0,0,0-1,.12,5.32,5.32,0,0,1-1.43.17h-2.39c-.62,0-.93,0-1.24,0s-.58,0-1.15,0a5.31,5.31,0,0,1-1.45-.19,3.06,3.06,0,0,0-.94-.12h-2.39c-.57,0-.86,0-1.15,0s-.62,0-1.24,0a9,9,0,0,1-1.33-.09,8.33,8.33,0,0,0-1.07-.06,2.2,2.2,0,0,0-.87.15,4.34,4.34,0,0,1-1.52.25,3.58,3.58,0,0,1-1.61-.35,1.5,1.5,0,0,0-.78-.19,2.1,2.1,0,0,0-.85.16,3.86,3.86,0,0,1-1.55.29h-4.77a4.83,4.83,0,0,1-1.45-.19,3.16,3.16,0,0,0-.94-.12,1.65,1.65,0,0,0-.81.17,3.69,3.69,0,0,1-1.58.32,4.1,4.1,0,0,1-1.53-.26,2.14,2.14,0,0,0-.86-.15H472a3.83,3.83,0,0,0-1,.11,5.77,5.77,0,0,1-1.41.16,11.59,11.59,0,0,1-1.3-.07,8.45,8.45,0,0,0-1.09-.06,12.07,12.07,0,0,1-1.27-.05c-.28,0-.56,0-1.12,0a9.18,9.18,0,0,1-1.32-.08,6.77,6.77,0,0,0-1.08-.07,4.63,4.63,0,0,1-1.25-.18,2.49,2.49,0,0,0-.33-.07s-.06,0-.16.14l-.1.11s.07.1.11.2a4,4,0,0,1,.29,1.43,5.89,5.89,0,0,1-.15,1.41,3.77,3.77,0,0,0-.11,1,6.43,6.43,0,0,0,.07,1.05,7.56,7.56,0,0,1,.1,1.34,1.88,1.88,0,0,0,.16.83,3.66,3.66,0,0,1,.3,1.55,5.89,5.89,0,0,1-.15,1.41,3.37,3.37,0,0,0-.11,1c0,.61,0,.92,0,1.23s0,.58,0,1.15a6.62,6.62,0,0,1-.13,1.38,4.58,4.58,0,0,0-.09,1,6.48,6.48,0,0,0,.07,1.06,9.18,9.18,0,0,1,.08,1.32c0,.61,0,.91,0,1.21s0,.59,0,1.18a9.13,9.13,0,0,1-.08,1.31,6.62,6.62,0,0,0-.07,1.07,2.16,2.16,0,0,0,.16.86,4.29,4.29,0,0,1,.26,1.52,4.83,4.83,0,0,1-.21,1.47,2.62,2.62,0,0,0-.13.91,4,4,0,0,0,.1,1,5.79,5.79,0,0,1,.15,1.4,4,4,0,0,1-.27,1.52,2,2,0,0,0-.16.86,2.16,2.16,0,0,0,.15.87,4.33,4.33,0,0,1,.24,1.51,4.53,4.53,0,0,1-.21,1.47,2.62,2.62,0,0,0-.13.91c0,.57,0,.85,0,1.13s0,.62,0,1.25,0,.94,0,1.26,0,.56,0,1.12a3.91,3.91,0,0,0,.1,1,5.86,5.86,0,0,1,.15,1.4,8.39,8.39,0,0,0,.06,1.08,11.07,11.07,0,0,1,.07,1.29c0,.64,0,.95-.05,1.27s0,.55,0,1.11a12.07,12.07,0,0,1-.05,1.27c0,.28-.05.56-.05,1.11a1.93,1.93,0,0,0,.16.84,3.81,3.81,0,0,1,.29,1.54,6.5,6.5,0,0,1-.13,1.37,5.45,5.45,0,0,0-.09,1,6.56,6.56,0,0,1-.12,1.36,4.87,4.87,0,0,0-.09,1,8.82,8.82,0,0,1-.09,1.32,6.57,6.57,0,0,0-.07,1.06,1.41,1.41,0,0,0,.19.75,3.62,3.62,0,0,1,0,3.25,1.43,1.43,0,0,0-.18.76,6,6,0,0,0,.08,1,6.37,6.37,0,0,1,.12,1.35,8.87,8.87,0,0,0,.05,1.08,9.35,9.35,0,0,1,.07,1.3c0,.58,0,.87,0,1.16s0,.61,0,1.22a3.81,3.81,0,0,1-.29,1.54,1.93,1.93,0,0,0-.16.84,6.05,6.05,0,0,0,.08,1,7.56,7.56,0,0,1,.1,1.34V221a2.94,2.94,0,0,0,.13.91,4.42,4.42,0,0,1,.22,1.47,6.56,6.56,0,0,1-.12,1.36,4.8,4.8,0,0,0-.09,1c0,.55,0,.83,0,1.11a12.21,12.21,0,0,1,.05,1.27c0,.55,0,.83,0,1.11a12.13,12.13,0,0,1,.05,1.26c0,.62,0,.93,0,1.24s0,.57,0,1.14,0,.88,0,1.17,0,.61,0,1.21a3.81,3.81,0,0,1-.31,1.56,1.73,1.73,0,0,0-.17.82,5.24,5.24,0,0,1-.2,1.31,1.81,1.81,0,0,0-.08.43Z"
  })))))));
}

export default __webpack_public_path__ + "static/box.64db348f.svg";
export { SvgBox as ReactComponent };